import { api } from "./api";
import { AbTest, AbTestVariant } from "../types";
import { TAGS } from "../constants";

export const experimentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getExperiments: builder.query<
      { data: AbTest[]; count: number },
      { from?: number; to?: number }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/experiments`,
        params,
      }),
      providesTags: [TAGS.EXPERIMENTS],
    }),
    getVariantsForExperiment: builder.query<AbTestVariant[], string>({
      query: (experimentId) => ({
        method: "GET",
        url: `/api/experiments/${experimentId}/variants`,
      }),
      providesTags: (_returns, _error, args) => [
        {
          type: TAGS.EXPERIMENT_VARIANTS,
          id: args,
        },
      ],
    }),
    getResultsForExperiment: builder.query<
      { total_assigned: number; events: [] },
      string
    >({
      query: (experimentId) => ({
        method: "GET",
        url: `/api/experiments/${experimentId}/results`,
      }),
      providesTags: (_returns, _error, args) => [
        {
          type: TAGS.EXPERIMENT_RESULTS,
          id: args,
        },
      ],
    }),
    createExperiment: builder.mutation<
      AbTest,
      {
        name: string;
        description: string;
        productArgs: { id: number; category_id: number }[];
      }
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/experiments`,
        body,
      }),
      invalidatesTags: [TAGS.EXPERIMENTS],
    }),

    createVariant: builder.mutation<
      AbTestVariant,
      { name: string; description: string; experiment_id: number }
    >({
      query: ({ experiment_id, ...body }) => ({
        method: "POST",
        url: `/api/experiments/${experiment_id}/variants`,
        body,
      }),
      invalidatesTags: (_returns, _error, args) => [
        {
          type: TAGS.EXPERIMENT_VARIANTS,
          id: args.experiment_id,
        },
      ],
    }),
    updateExperiment: builder.mutation<
      AbTest,
      {
        id: number;
        name?: string;
        description?: string | null;
        is_active?: boolean;
        product_ids?: number[];
      }
    >({
      query: ({ id, ...body }) => ({
        method: "PUT",
        url: `/api/experiments/${id}`,
        body,
      }),
      invalidatesTags: [TAGS.EXPERIMENTS],
    }),
  }),
});

export const {
  useGetExperimentsQuery,
  useGetVariantsForExperimentQuery,
  useGetResultsForExperimentQuery,
  useCreateExperimentMutation,
  useCreateVariantMutation,
  useUpdateExperimentMutation,
} = experimentsApi;
